<header class="topbar">
  <button
    type="button"
    class="menu-toggle"
    [attr.aria-label]="'shared.nav.toggleMenu' | translate"
    [attr.aria-expanded]="layout.sidebarOpen()"
    (click)="layout.toggleSidebar()"
  >
    <app-icon name="menu" [size]="20" />
  </button>

  <div class="brand">
    @if (branding.logoUrl(); as logoUrl) {
      <img class="mark logo" [src]="logoUrl" alt="" />
    } @else {
      <img class="mark logo" src="/branding/app-logo.png" [alt]="'shared.logoAlt' | translate" />
    }
    <span class="org-name" [title]="organizationLabel">{{ organizationLabel }}</span>
  </div>

  <div class="actions">
    <div class="lang-menu" #langMenu>
      <button type="button" class="lang-trigger" [attr.aria-label]="'shared.language' | translate" (click)="toggleLangMenu()">
        <app-icon name="globe" [size]="15" />
        {{ currentLocale.toUpperCase() }}
        <app-icon name="chevron-down" [size]="12" />
      </button>
      @if (isLangMenuOpen()) {
        <div class="lang-panel">
          @for (loc of locales; track loc) {
            <button type="button" class="lang-option" [class.active]="loc === currentLocale" (click)="setLocale(loc)">
              {{ loc.toUpperCase() }}
            </button>
          }
        </div>
      }
    </div>

    <div class="notifications-menu" #notificationsMenu>
      <button type="button" class="bell" [attr.aria-label]="'shared.notifications' | translate" (click)="toggleNotifications()">
        <app-icon name="bell" [size]="18" />
        @if (unreadCount() > 0) {
          <span class="badge">{{ unreadCount() }}</span>
        }
      </button>
      @if (isNotificationsOpen()) {
        <div class="notifications-panel">
          <div class="notifications-header">{{ 'shared.notificationsPanel.title' | translate }}</div>
          @if (loadingNotifications()) {
            <p class="notifications-empty">{{ 'shared.notificationsPanel.loading' | translate }}</p>
          } @else if (recentNotifications().length === 0) {
            <p class="notifications-empty">{{ 'shared.notificationsPanel.empty' | translate }}</p>
          } @else {
            <ul>
              @for (item of recentNotifications(); track item.id) {
                <li
                  [class.unread]="item.isUnread"
                  [class.clickable]="canOpen(item)"
                  [attr.tabindex]="canOpen(item) ? 0 : null"
                  [attr.role]="canOpen(item) ? 'button' : null"
                  (click)="canOpen(item) && openNotification(item)"
                  (keydown.enter)="canOpen(item) && openNotification(item)"
                >
                  <span class="notification-title">
                    {{ notificationTitle(item) }}
                    @if (entityRefLabel(item); as ref) {
                      <span class="notification-ref">{{ ref }}</span>
                    }
                  </span>
                  <span class="notification-time">{{ item.sentAt | date: 'short' }}</span>
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>

    <div class="user-menu" #userMenu>
      <button type="button" class="user-trigger" (click)="toggleUserMenu()">
        <span class="avatar">{{ userInitials }}</span>
        <span class="user-info">
          <span class="user-name">{{ auth.currentUser()?.fullName }}</span>
          @if (primaryRoleLabel) {
            <span class="user-role">{{ primaryRoleLabel }}</span>
          }
        </span>
        <app-icon name="chevron-down" [size]="12" />
      </button>
      @if (isUserMenuOpen()) {
        <div class="user-panel">
          <button type="button" (click)="logout()">
            <app-icon name="log-out" [size]="15" />
            {{ 'shared.signOut' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</header>
